<template>
  <div class="filter">
    <div class="filter_form">
      <div class="level bottom">
        <div class="level-left">
          <b-field class="input_checkbox">
            <b-checkbox @input="$emit('handle-change')" v-model="search.trashed" type="is-info">
              Показать архивные
            </b-checkbox>
          </b-field>
        </div>
        <div class="level-right filter_actions" v-if="userRole != 'leader'">
          <button @click="$emit('delete')" v-if="!search.trashed" :disabled="!rows.checked.length">
            <i class="mdi mdi-account-remove-outline"></i> В архив
          </button>
          <button @click="$emit('restore')" v-else :disabled="!rows.checked.length">
            <i class="mdi mdi-account-check-outline"></i> Восстановить
          </button>
          <button class="delete_course" @click="$emit('create-user')">
            <i class="mdi mdi-account-plus-outline"></i> Добавить студентов
          </button>
          <button class="add_course" @click="$emit('create-leader')">
            <i class="mdi mdi-account-plus-outline"></i> Добавить руководителя
          </button>
        </div>
      </div>
      <form class="level" @submit.prevent="$emit('handle-change')">
        <b-field label="Поиск по ФИО:" class="branch_search input_search with_button" type="is-info">
          <b-input placeholder="Поиск пользователей" v-model="search.name"></b-input>
          <button type="submit">Поиск</button>
        </b-field>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    search: {
      default: () => {},
      type: Object
    },
    rows: {
      default: () => {},
      type: Object
    }
  },
  computed: {
    userRole() {
      return this.$store.state.auth.role[0]
    }
  }
}
</script>
